import { render, staticRenderFns } from "./AppAsideBar.vue?vue&type=template&id=931563c0&scoped=true"
import script from "./AppAsideBar.vue?vue&type=script&lang=js"
export * from "./AppAsideBar.vue?vue&type=script&lang=js"
import style0 from "./AppAsideBar.vue?vue&type=style&index=0&id=931563c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "931563c0",
  null
  
)

export default component.exports